import { api, ApiError } from 'shared/api';

import { AuthData, AvailableTenant, User, UserInfo } from './types';

interface AvailableTenantResponse {
    availableTenants: AvailableTenant[];
}

export async function getUserInfoForCandidate() {
    return api.post<void, UserInfo>('auth/getUserInfoForCandidate', undefined);
}

export async function getCurrentUser() {
    return api.get<User>('user/currentUser');
}

export async function getAvailableTenants() {
    const response = await api.get<AvailableTenantResponse>('auth/getAvailableTenants');

    if (response instanceof ApiError) {
        return response;
    }

    return response.availableTenants;
}

export async function fetchCurrentCandidateEmail() {
    return await api.get<string>('candidatePortal/candidates/email');
}

export const getAuthData = async (): Promise<AuthData | ApiError> =>
    await api.get<AuthData | ApiError>(`/Auth/GetAuthData`);
